import {createStore} from 'zustand';
import {ServiceRequestStatusesByDate} from '../constants/service-requests-statuses-by-date';

interface ServiceRequestsStatusFiltersStore {
  statusFilter: ServiceRequestStatusesByDate[];
  setStatusFilter: (statusFilter: ServiceRequestStatusesByDate[]) => void;
}

export const fullFilter: ServiceRequestStatusesByDate[] = [
  ServiceRequestStatusesByDate.COMPLETED_NOT_CLOSED,
  ServiceRequestStatusesByDate.COMPLETED_ON_TIME,
  ServiceRequestStatusesByDate.IN_PROGRESS,
  ServiceRequestStatusesByDate.DEADLINE_OVERDUE,
  ServiceRequestStatusesByDate.DEADLINE_SOON,
];

export const createServiceRequestsStatusFiltersStore = () =>
  createStore<ServiceRequestsStatusFiltersStore>((set) => ({
    statusFilter: fullFilter,
    setStatusFilter: (newFilter: ServiceRequestStatusesByDate[]) => {
      if (!newFilter.length) {
        set({statusFilter: fullFilter});
      } else {
        set({statusFilter: newFilter});
      }
    },
  }));
